"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeStore = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = require("styled-components");
const emotion_theming_1 = require("emotion-theming");
const theme_1 = require("./theme");
const react_light_state_1 = __importDefault(require("react-light-state"));
const GlobalStyle = styled_components_1.createGlobalStyle `
  body {
    margin: 0;
    padding: 0;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif ;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /* background: #eee; */
    color: #111;
  }
  button, input {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif ;
  }
`;
exports.ThemeStore = new react_light_state_1.default({ theme: "light" }, "themeStore", {
    storageName: "ui-settings",
});
function default_1({ children, themeLight, themeDark, theme }) {
    // @ts-ignore
    const themeString = theme || exports.ThemeStore.useStore((state) => state.theme);
    return (react_1.default.createElement(emotion_theming_1.ThemeProvider, { theme: themeString === "light"
            ? themeLight || theme_1.themeDefault
            : themeDark || theme_1.themeDark },
        react_1.default.createElement(GlobalStyle, null),
        children));
}
exports.default = default_1;
//# sourceMappingURL=index.js.map